module.exports = __webpack_public_path__ + "img/cocational_fileList1.d61b2c55.jpg";